import { CouponCodeFormFieldsName, HaveCouponCodeOptionValue } from "./enum";
import { ApiRegistrationParticipantForParticipantResponse } from "../../../../shared/types/ApiRegistrationParticipantForParticipantResponse";
import { ApiApplicableRateCardDetails } from "../../../../shared/types/ApiApplicableRateCardDetails";

export enum Action {
  UPDATE_STEP = "UPDATE_STEP",
  UPDATE_COUPON_CODE_FORM_VALUES = "UPDATE_COUPON_CODE_FORM_VALUES",
  UPDATE_PARTICIPANT_DATA = "UPDATE_PARTICIPANT_DATA",
  UPDATE_STEP_AND_PARTICIPANT_DATA = "UPDATE_STEP_AND_PARTICIPANT_DATA",
  UPDATE_COUPON_CODE_APPLICABLE_FLOW = "UPDATE_COUPON_CODE_APPLICABLE_FLOW"
}

export interface PurchaseTicketArgsType {
  openAssignTicketToSelfHandler: () => void;
  dismissPurchaseTicketHandler?: () => void;
}

export interface UpdateStepAndParticipantDataArgType {
  stepNo: number;
  participantData?: ApiRegistrationParticipantForParticipantResponse;
}

export interface CouponCodeSuccessHandlerArgsType {
  couponCodeFormValues: CouponCodeFormValueType;
  applicableRateCardDetails?: ApiApplicableRateCardDetails;
}

export interface HaveCouponCodeFormArgsType {
  successHandler: (props: CouponCodeSuccessHandlerArgsType) => void;
  couponCodeFormValues?: CouponCodeFormValueType;
  state: State;
  dispatcher: DispatchInterface;
  openAssignTicketToSelfHandler: () => void;
}

export interface CouponCodeFormValueType {
  [CouponCodeFormFieldsName.HAVE_COUPON_CODE]?: HaveCouponCodeOptionValue;
  [CouponCodeFormFieldsName.COUPON_CODE]?: string;
  applicableRateCardDetailsByCouponCode?: ApiApplicableRateCardDetails;
}

export interface State {
  stepNo?: number;
  couponCodeFlowApplicable: boolean;
  couponCodeFormValues?: CouponCodeFormValueType;
  participantData?: ApiRegistrationParticipantForParticipantResponse;
}

export type ActionType =
  | { type: Action.UPDATE_STEP; payload: number }
  | { type: Action.UPDATE_COUPON_CODE_APPLICABLE_FLOW; payload: boolean }
  | { type: Action.UPDATE_COUPON_CODE_FORM_VALUES; payload: CouponCodeFormValueType }
  | {
      type: Action.UPDATE_PARTICIPANT_DATA;
      payload: ApiRegistrationParticipantForParticipantResponse;
    }
  | { type: Action.UPDATE_STEP_AND_PARTICIPANT_DATA; payload: UpdateStepAndParticipantDataArgType };

export interface DispatchInterface {
  updateStep: (stepNumber: number) => void;
  updateCouponCodeApplicableFlow: (i: boolean) => void;
  updateCouponCodeFormValues: (payload: CouponCodeFormValueType) => void;
  updateParticipantData: (data: ApiRegistrationParticipantForParticipantResponse) => void;
  updateStepAndParticipantData: (props: UpdateStepAndParticipantDataArgType) => void;
}
